"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var R = _interopRequireWildcard(require("ramda"));

var _remark = _interopRequireDefault(require("remark"));

var _mdastUtilToHast = _interopRequireDefault(require("mdast-util-to-hast"));

var _unistUtilRemovePosition = _interopRequireDefault(require("unist-util-remove-position"));

var _hastUtilRaw = _interopRequireDefault(require("hast-util-raw"));

var _bluebird = _interopRequireDefault(require("bluebird"));

function applyPlugins() {
  return _applyPlugins.apply(this, arguments);
}

function _applyPlugins() {
  _applyPlugins = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function () {
    function _callee() {
      var plugins,
          ast,
          _args = arguments;
      return _regenerator["default"].wrap(function () {
        function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                plugins = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
                ast = _args.length > 1 ? _args[1] : undefined;
                _context.next = 4;
                return _bluebird["default"].each(plugins, function (plugin) {
                  var requiredPlugin = plugin.resolved;

                  if (R.is(Function, requiredPlugin)) {
                    return requiredPlugin({
                      markdownAST: ast
                    }, plugin.pluginOptions);
                  }

                  return _bluebird["default"].resolve();
                });

              case 4:
                return _context.abrupt("return", ast);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }

        return _callee$;
      }(), _callee, this);
    }

    return _callee;
  }()));
  return _applyPlugins.apply(this, arguments);
}

function setParserPlugins() {
  var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var remark = arguments.length > 1 ? arguments[1] : undefined;
  return plugins.reduce(function (nextRemark, plugin) {
    var requiredPlugin = plugin.resolved;
    if (!R.is(Function, requiredPlugin.setParserPlugins)) return nextRemark;
    return requiredPlugin.setParserPlugins(plugin.pluginOptions).reduce(function (acc, parserPlugin) {
      if (Array.isArray(parserPlugin)) {
        var _parserPlugin = (0, _slicedToArray2["default"])(parserPlugin, 2),
            parser = _parserPlugin[0],
            options = _parserPlugin[1];

        return acc.use(parser, options);
      }

      return acc.use(parserPlugin);
    }, nextRemark);
  }, remark);
}

function useRemark(content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useState = (0, _react.useState)({
    type: 'root',
    children: []
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      htmlAst = _useState2[0],
      setHtmlAst = _useState2[1];

  var optionsRef = (0, _react.useRef)(options);
  (0, _react.useEffect)(function () {
    if (!content) return;
    var remark = new _remark["default"]().data('settings', {
      commonmark: true,
      footnotes: true,
      gfm: true,
      pedantic: true
    });
    remark = setParserPlugins(optionsRef.current.plugins, remark);
    applyPlugins(optionsRef.current.plugins, remark.parse(content)).then(function (ast) {
      return (0, _mdastUtilToHast["default"])(ast, {
        allowDangerousHTML: true
      });
    }).then(function (ast) {
      var strippedAst = (0, _unistUtilRemovePosition["default"])(ast, true);
      setHtmlAst((0, _hastUtilRaw["default"])(strippedAst));
    });
  }, [content]);
  return {
    childMarkdownRemark: content ? {
      htmlAst: htmlAst
    } : null
  };
}

var _default = useRemark;
exports["default"] = _default;